import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { EventPreviewSmallComponent } from '@modules/calendar-app/components/event-preview/event-preview-small.component';
import { type CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { DynamicPanelModule } from '@modules/dynamic-panel/dynamic-panel.module';
import { ClickDirective } from '@modules/utils/directives/click/click.directive';
import { Objects } from '@sharedlib/common/lang/Objects';

@Component({
  selector: 'stch-small-events-preview-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicPanelModule, EventPreviewSmallComponent, ClickDirective],
  template: `<div class="flex flex-col gap-2">
    @for (event of eventsToShow(); track $index) {
      <stch-event-preview-small
        [event]="event"
        (appClick)="eventClicked.emit(event)"
        (appDblClick)="eventDblClicked.emit(event)"
        [appClickStopPropagation]="true"
      />
    }
  </div>`,
})
export class SmallEventsPreviewListComponent {
  public readonly events = input.required<CalendarEvent[]>();
  public readonly maxEvents = input<number>();
  public readonly clickOpensInDP = input<boolean>(true);

  protected readonly eventClicked = output<CalendarEvent>();
  protected readonly eventDblClicked = output<CalendarEvent>();

  protected readonly eventsToShow = computed(() => {
    const max = this.maxEvents();
    if (Objects.isNullOrUndefined(max) || max <= 0) {
      return this.events();
    } else {
      return this.events().slice(0, max);
    }
  });
}
